import Alert from '@mui/material/Alert';
import { ApiError } from '../api/client';

export interface QueryErrorMessages {
  /** Shown for a 5xx, a network failure, or anything else without a usable message. */
  failed: string;
  /** Shown for QUERY_TOO_EXPENSIVE where the API's "narrow it" advice has no control to act on. */
  tooExpensive?: string | undefined;
}

/** The API's own message only for a 4xx in its { error, code } shape. Others can be raw text. */
export function queryErrorMessage(error: unknown, messages: QueryErrorMessages): string {
  if (!(error instanceof ApiError) || error.status < 400 || error.status >= 500) {
    return messages.failed;
  }
  if (error.code === 'QUERY_TOO_EXPENSIVE') return messages.tooExpensive ?? error.message;
  return error.code === 'HTTP_ERROR' ? messages.failed : error.message;
}

export function QueryErrorAlert({ error, ...messages }: QueryErrorMessages & { error: unknown }) {
  return <Alert severity="error">{queryErrorMessage(error, messages)}</Alert>;
}
